import React from 'react';
import { Link } from 'react-router-dom';
import hero from '../assets/Car Gallery (1).png';

function HeroImg() {
  return (
    <section className="hero-section">
      <div className="content-shell hero-grid">
        <div>
          <p className="eyebrow">Seçkin otomobiller · Tek koleksiyon</p>
          <h1 className="hero-title">Yolun en iyi <span>halini keşfet.</span></h1>
          <p className="hero-copy">
            Karakteri, performansı ve tasarımıyla öne çıkan otomobilleri sade bir deneyimle inceleyin.
          </p>
          <div className="hero-actions">
            <Link className="primary-button" to="/carshow">Koleksiyonu keşfet</Link>
            <Link className="ghost-button" to="/cartable">Tüm araçlar</Link>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-image-frame"><img src={hero} alt="Car Gallery seçkin otomobil koleksiyonu" /></div>
          <div className="hero-stat"><strong>10+</strong><span>özenle seçilmiş araç</span></div>
        </div>
      </div>
    </section>
  );
}

export default HeroImg;
